$('#student_group_select').change(function () {
    if ($('#student_group_select').val().length == 0) {
        $('#donationFormElements').attr('x-data', "{ student_group_selected: false, show_student_group_player: false }");
    } else {
        $('#donationFormElements').attr('x-data', "{ student_group_selected: true }");
    }
});
